module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "rt-nav-item",
    class: {
      "is-active": _vm.active, "is-disabled": _vm.disabled
    },
    on: {
      "click": _vm.handleItemClick
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a4b3f54"}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/nav/src/nav-item.vue
// module id = 606
// module chunks = 15